'use client';

import { Image } from '@petsmart-ui/sparky';
import { getENV, getIconSrc } from '../../utils';
import type { LegacyIconProps } from './types';

export function LegacyIcon({ name, size, isPriority, className }: Readonly<LegacyIconProps>) {
    const pageType = getENV('NEXT_PUBLIC_APP_NAME');
    const iconSrc = getIconSrc(pageType ?? 'plp', name);
    // NOTE: Legacy icons are a mix between custom font icons with icomoon.io and png images.
    // As the legacy design is temporary, we don't want to invest time in creating a new icon system.
    return (
        <>
            {isPriority && <link rel="preload" key={iconSrc} href={iconSrc} as="image" />}

            <Image
                data-testid="legacy-icon"
                src={iconSrc}
                alt={`icon ${name}`}
                className={className}
                loading={isPriority ? 'eager' : 'lazy'}
                width={size}
            />
        </>
    );
}
